import { ColorV2 } from "config/colors";
import {
  BaseButton,
  BaseButtonStyle,
  ButtonSize,
} from "components/designV2/buttons/baseButton";

/** Props for the secondary button component. */
export interface SecondaryButtonProps extends Omit<
  React.ButtonHTMLAttributes<HTMLButtonElement>,
  "type"
> {
  expandIconLabelOnHover?: boolean;
  label?: string;
  iconName?: string;
  size?: ButtonSize;
  type?: "button" | "submit" | "reset";
  styleOverrides?: Partial<BaseButtonStyle>;
  isLoading?: boolean;
}

const SECONDARY_STYLES = {
  backgroundColor: "transparent",
  textColor: ColorV2.Blue1,
  borderColor: ColorV2.Blue1,
  hoverBackgroundColor: ColorV2.Blue6,
  activeBackgroundColor: ColorV2.Blue5,
  disabledBackgroundColor: "transparent",
  disabledTextColor: ColorV2.Blue5,
  disabledBorderColor: ColorV2.Blue6,
  iconColor: ColorV2.Blue1,
  disabledIconColor: ColorV2.Blue5,
};

/** Secondary button variant built on top of BaseButton. */
export const SecondaryButton = ({
  label,
  iconName,
  size = "large",
  type = "button",
  disabled,
  isLoading = false,
  styleOverrides,
  ...rest
}: SecondaryButtonProps): JSX.Element => {
  const resolvedStyles: BaseButtonStyle = {
    ...SECONDARY_STYLES,
    ...styleOverrides,
  };

  return (
    <BaseButton
      label={label}
      iconName={iconName}
      size={size}
      type={type}
      disabled={disabled}
      isLoading={isLoading}
      styles={resolvedStyles}
      {...rest}
    />
  );
};
